import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store';
import {authModules, guestModules} from '@/router/modules';
import ErrorHandler from '@/router/error-handler';
import SecurityGuard from '@/router/security-guard';
import MetaGuard from '@/router/meta-guard';
import VendorGuard from '@/router/vendor-guard';
import moment from 'moment';

Vue.use(Router);

const GuestLayout = () => import('@/modules/layouts/guest.vue');
const MainLayout = () => import('@/modules/layouts/main.vue');

const routes = [
    {
        path: '/guest',
        redirect: '/login',
        component: GuestLayout,
        children: guestModules,
    },
    {
        path: '/main',
        redirect: '/dashboard',
        component: MainLayout,
        children: authModules,
    },
    {
        path: '/impersonate',
        name: 'impersonate',
        beforeEnter: (to) => {
            store.dispatch('app/impersonate', {to});
        },
        meta: {
            authorized: false,
        },
    },
    {
        // wildcard path will redirect to login
        // if no other rule matches it
        path: '*',
        redirect: '/dashboard',
    },
];

const router = new Router({
    mode: 'history',
    // TODO disable routes in styleguide
    routes: process.env.VUE_APP_IS_STYLEGUIDE ? [] : routes,
    linkActiveClass: 'is-active',
});

// register error handler
router.onError(ErrorHandler.middleware);

// define route guards for security and meta;
const security = new SecurityGuard(store);

const fetchData = (newRoute, oldRoute) => {
    const isGuest = store.getters['user/isGuest'];
    const fetchedTime = store.getters['user/profileFetchedTime'];
    const needsToBeFetched = moment(fetchedTime).add(20, 'm').isBefore();
    if ((!oldRoute.name || (newRoute !== oldRoute && !isGuest)) && needsToBeFetched) {
        store.dispatch('app/synchronize');
    }
};

// TODO disable in styleguide
if (!process.env.VUE_APP_IS_STYLEGUIDE) {
    router.beforeEach((to, from, next) => {
        security.middleware(to, from, (params) => {
            MetaGuard.middleware(to);
            // update vendor libs as needed (e.g. Intercom)
            VendorGuard.middleware({store, to});
            next(params);
        });

        fetchData(to, from);
    });
    router.afterEach(({fullPath, meta}) => {
        // save only authorized paths
        if (meta && meta.authorized) {
            store.dispatch('router/setPath', fullPath);
        }
    });
}

export default router;
